<template>
  <div>
    <NBar title="添加投放地址"/>
    <div class='item-div'>
      <nut-cell :show-icon="true" style="margin-bottom: 10px;" @click.native="openMerchant()">
        <span slot="title">选择商家：</span>
        <span slot="desc">{{merName != null && merName != '' ? merName : '请选择商家'}}</span>
      </nut-cell>
      <!--选择商家弹窗-->
      <nut-popup v-model="showMerchant" position="bottom" closeable :style="{height: '70%'}">
        <div class="popup-top-div">
          <nut-cell style="margin-top: -3px;">
            <span slot="title" style="font-size: 16px;">选择商家</span>
          </nut-cell>
          <nut-searchbar ref="merchantSearch" @submit="merchantSearch" v-model="merchantSearchName" place-text="请输入商家名称"
                         style="margin: 10px;"/>
        </div>
        <m-list style="height:calc(100vh - 300px);" ref="merchantList" :data.sync="merchantList"
                :page.sync="merchantPage" :limit.sync="merchantLimit" @loadlist="getMerchantList">
          <div slot="list">
            <nut-cell v-for="(item ,index) in merchantList" :key="index">
              <span slot="title">{{item.name}}</span>
              <span slot="desc">
                <nut-radio v-model="selectMerchantIndex" :label="index"/>
              </span>
            </nut-cell>
          </div>
        </m-list>
        <div class="bottom">
          <nut-button class="btn" small @click.native="merchantConfirm">确定</nut-button>
        </div>
      </nut-popup>
      <div class='item'>
        <nut-textinput :show-icon="true" label="场地名称：" placeholder="请填写场地名称" v-model="saveForm.name" :clearBtn="false"
                       :has-border="false" style="width: 100%;"/>
      </div>
      <div class='item'>
        <nut-cell isLink title="地区：" :showIcon="true" style="width: 100%;padding: 0"
                  @click-cell="showAddress">
          <span v-if="address == ''" slot="desc">请选择地区</span>
          <span v-else slot="desc">{{address}}</span>
        </nut-cell>
      </div>
      <div class='item'>
        <nut-textinput label="详细地址：" placeholder="请填写详细地址" v-model="saveForm.address" :clearBtn="false"
                       :has-border="false"/>
      </div>
      <nut-cell isLink title="地区类型：" :showIcon="true" @click.native="isVisible= true"
                style="padding: 0;margin: 0 10px;">
        <span slot="desc">{{saveForm.typeName}}</span>
      </nut-cell>
      <nut-actionsheet :is-visible="isVisible" @close="isVisible = false">
        <div slot="custom">
          <div class="modal-header">
            <span class="btn" @click="isVisible = false">取消</span>
            <span class="text">请选择投放地址的场所类型</span>
            <span class="btn" @click="ok()"> 确定</span>
          </div>
          <div class="site">
            <div v-for="(item,index) in siteList" :key="index" @click="selectLabel(index)"
                 :class='siteLabelIndex == index ? "site-label on" : "site-label"'>
              {{item.name}}
            </div>
          </div>
        </div>
      </nut-actionsheet>
      <nut-cell isLink title="体验项目：" :showIcon="true" @click.native="openService()"
                style="padding: 0; margin: 0 10px;">
        <span slot="desc">{{serviceLabelName}}</span>
      </nut-cell>
      <nut-actionsheet :is-visible="isServiceVisible" @close="isServiceVisible = false">
        <div slot="custom">
          <div class="modal-header">
            <span class="btn" @click="isServiceVisible = false">取消</span>
            <span class="text">请选择体验项目</span>
            <span class="btn" @click="okService"> 确定</span>
          </div>
          <div class="site" style="height: 200px;padding-top: 10px;">
            <m-list style="height:calc(100vh - 340px);" ref="serviceList" :data.sync="serviceList">
              <div slot="list">
                <nut-cell v-for="(item ,index) in serviceList" :key="index">
                  <span slot="title">{{item.name}}</span>
                  <span slot="desc">
                    <nut-checkbox v-model='item.checked' @change="changeService($event,item,index)"/>
                  </span>
                </nut-cell>
              </div>
            </m-list>
          </div>
        </div>
      </nut-actionsheet>
      <div class='item'>
        <div class="title-item">
          <span>设为默认投放地址</span>
          <span class="text">每次注册设备时使用该地址</span>
        </div>
        <nut-switch :active="swActive" @change="defaultChange($event)" class="my-switch"></nut-switch>
      </div>
      <nut-address v-model="showPopup" :province="province" :city="city" :country="country"
                   :town="town" customAddressTitle="" @onChange="onChange" @close="close">
      </nut-address>
    </div>
    <nut-button style="margin: 30px 15px;border-radius: 5px;width:92%;" @click.native="save()">保存</nut-button>
  </div>
</template>

<script>
export default {
  name: 'AddressAdd',
  props: ['data'],
  data () {
    return {
      saveForm: {
        id: null,
        merId: null,
        storeId: null,
        name: '',
        province: null,
        city: null,
        area: null,
        address: '',
        type: null,
        typeName: '',
        isDefault: 1,
        testService: '',
        provinceName: '',
        cityName: '',
        areaName: '',
      },
      swActive: true,
      /** 设备场所*/
      siteList: [],
      siteLabelIndex: null,
      siteLabelName: '',
      isVisible: false,
      showPopup: false,
      //是否显示选择商家
      showMerchant: false,
      merchantList: [],
      merchantSearchName: '',
      merchantPage: 1,
      merchantLimit: 6,
      selectMerchantIndex: 0,
      merName: null,
      /**项目列表*/
      serviceList: [],
      isServiceVisible: false,
      selectService: '',
      serviceLabelName: '选择体验项目',
      province: [], // 省
      city: [],// 市
      country: [],// 县
      town: [], // 镇 必传值：name
      address: '',
      multiArray: [], // 三维数组数据
      multiIndex: [0, 0, 0], // 默认的下标
      step: 0 // 默认显示请选择

    }
  },
  activated () {
    this.user = this.$api.user
    this.merId = this.$api.user.merId
    this.storeId = this.$api.user.storeId
    this.merName = ''
    if (this.data != null) {
      let data = JSON.parse(decodeURIComponent(this.data))
      this.$util.ofData(this.saveForm, data)
      this.address = this.saveForm.provinceName + '省 ' + this.saveForm.cityName + '市 ' + this.saveForm.areaName
      if (!this.$util.isArrOrNull(data.merName)) {
        this.merName = data.merName
      }
      if (this.saveForm.isDefault == 1) {
        this.swActive = true
      } else {
        this.swActive = false
      }
      //体验项目
      this.selectService = this.saveForm.testService
      if (this.selectService.length <= 0) {
        this.serviceLabelName = '请选择体验项目'
      } else {
        this.serviceLabelName = '已选择' + this.selectService.split(',').length + '个体验项目'
      }
    } else {
      this.address = ''
      this.merName = null
      Object.assign(this.$data.saveForm, this.$options.data().saveForm)
    }
    this.getMerchantList()
  },
  mounted () {
    this.getProvince()
    this.getDeviceSite()
    this.getTestService()
  },
  methods: {
    merchantSearch (value) {
      this.merchantPage = 1
      this.merchantSearchName = value
      //点击键盘中的’搜索‘时，失去焦点
      this.$refs.merchantSearch.blur()
      this.getMerchantList()
    },
    openMerchant () {
      if (this.data != null) {
        this.$toast.warn('商家无法修改')
        return
      }
      this.showMerchant = true
    },
    getMerchantList () {
      let data = {
        agentId: this.$api.agentId,
        status: 1,
        page: this.merchantPage,
        limit: this.merchantLimit
      }
      if (this.merchantSearchName != '') {
        data.name = this.merchantSearchName
      }
      this.$api.post({
        url: '/merchant/merchant/find/list',
        data: data
      }).then(res => {
        this.$refs.merchantList.setRes(res)
        this.merchantList.forEach(item => {
          if (item.id === this.saveForm.merId) {
            this.merName = item.name
          }
        })
      })
    },
    /**选择商户*/
    merchantConfirm () {
      let merchant = this.merchantList[this.selectMerchantIndex]
      this.merName = merchant.name
      this.saveForm.merId = merchant.id
      this.showMerchant = false
    },
    // 获取省
    getProvince () {
      this.$api.post({
        url: '/system/area/find',
        data: {
          areaPid: 0,
          areaType: 1
        },
      }).then(res => {
        if (res.data != null) {
          this.province = []
          res.data.forEach(item => {
            this.province.push({
              id: item.id,
              name: item.areaName
            })
          })
        }
        if (this.saveForm.province != null) {
          this.getCity(this.saveForm.province)
        }
      })
    },
    //获取市级数据
    getCity (code) {
      this.$api.post({
        url: '/system/area/find',
        data: {
          areaPid: code,
          areaType: 2
        }
      }).then(res => {
        if (res.data != null) {
          this.city = []
          res.data.forEach(item => {
            this.city.push({
              id: item.id,
              name: item.areaName
            })
          })
          if (this.saveForm.city != null) {
            this.getArea(this.saveForm.city)
          }
        }
      })
    },

    //获取区级数据
    getArea (code) {
      this.$api.post({
        url: '/system/area/find',
        data: {
          areaPid: code,
          areaType: 3
        }
      }).then(res => {
        if (res.data != null) {
          this.country = []
          res.data.forEach(item => {
            this.country.push({
              id: item.id,
              name: item.areaName
            })
          })
        }
      })
    },
    /*获取体验商品信息*/
    getTestService () {
      this.$api.post({
        url: '/device/api/device/device-service/list',
        data: {
          isTest: 1
        }
      }).then(res => {
        if (res.data != null) {
          this.serviceList = res.data
        }
      })
    },
    openService () {
      this.isServiceVisible = true
      if (this.saveForm.testService == null) {
        this.saveForm.testService = ''
      }
      this.selectService = this.saveForm.testService
      let list = this.$util.clone(this.serviceList)
      list.forEach(item => {
        if (this.selectService.split(',').indexOf(item.id.toString()) != -1) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
      this.serviceList = list
    },
    changeService (val, item, index) {
      if (val) {
        if (this.selectService.split(',').indexOf(item.id.toString()) == -1) {
          if (this.selectService.length == 0) {
            this.selectService = item.id.toString()
          } else {
            this.selectService = this.selectService + ',' + item.id
          }
        }
      } else {
        if (this.selectService.indexOf(',') == -1) {
          this.selectService = ''
        } else
          this.selectService = this.selectService.replace(',' + item.id, '')
      }
    },
    okService () {
      this.saveForm.testService = this.selectService
      this.isServiceVisible = false
      if (this.selectService.length <= 0) {
        this.serviceLabelName = '请选择体验项目'
      } else {
        this.serviceLabelName = '已选择' + this.selectService.split(',').length + '个体验项目'
      }
    },
    showAddress () {
      this.showPopup = true
    },
    onChange (cal) {
      if (cal.custom == 'province') {
        this.getCity(cal.value.id)
      }
      if (cal.custom == 'city') {
        this.getArea(cal.value.id)
      }
      if (cal.custom == 'country') {
        this.showPopup = false
      }
    },
    close (val) {
      this.address = val.data.province.name + '省 ' + val.data.city.name + '市 ' + val.data.country.name
      this.saveForm.province = val.data.province.id
      this.saveForm.city = val.data.city.id
      this.saveForm.area = val.data.country.id
    },
    getDeviceSite () {
      this.$api.post({
        url: '/device/api/device/device-site/list',
      }).then(res => {
        if (res.data != null) {
          this.siteList = res.data
        }
      })
    },
    selectLabel (index) {
      this.siteLabelIndex = index
      this.saveForm.type = this.siteList[this.siteLabelIndex].id
    },
    ok () {
      this.saveForm.typeName = this.siteList[this.siteLabelIndex].name
      this.isVisible = false
    },
    defaultChange (status) {
      if (status) {
        this.saveForm.isDefault = 1
      } else {
        this.saveForm.isDefault = 0
      }
    },
    save () {
      if (this.$util.isArrOrNull(this.saveForm.merId)) {
        this.$toast.warn('请选择商家')
        return
      }
      this.$api.post({
        url: '/device/api/device/address/save',
        data: this.saveForm,
      }).then(() => {
        setTimeout(() => {
          this.$router.go(-1)
        }, 1500)
      })
    }
  }
}
</script>

<style scoped>
  >>> .nut-address .custom-address .region-tab .region-tab-line {
    background: -webkit-gradient(linear, left top, right top, from(#1a87ff), to(#9ec6ff));
    background: linear-gradient(90deg, #1a87ff, #9ec6ff);
  }

  .item-div {
    background: #fff;
  }

  .item-div .item {
    margin-left: 12px;
    padding-right: 12px;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f9f9fb;
  }

  .item-div .item .title-item {
    display: flex;
    flex-direction: column;
    font-size: 14px;
  }


  .item-div .item .title-item .text {
    font-size: 12px;
    color: #666666;
  }

  .item-div .site {
    display: flex;
    flex-wrap: wrap;
    padding: 15px;
    background: #fff;
    height: 300px;
    overflow: auto;
  }

  .item-div .site-label {
    user-select: none;
    color: #8f8f94;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 8px 15px;
    border: 1px solid #8f8f94;
    margin: 0 10px 10px 0;
  }

  .item-div .on {
    background: #1a87ff;
    border: 1px solid #1a87ff;
    color: #ffffff;
  }

  .modal-header {
    height: 50px;
    padding: 0 10px;
    line-height: 50px;
    background: #fff;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .modal-header .btn {
    color: #1a87ff;
  }

  .bottom {
    width: 100%;
    position: fixed;
    bottom: 0;
    height: 45px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bottom .btn {
    flex: 1;
    border-radius: 0;
    height: 45px;
  }


  /deep/ .my-switch.nut-switch {
    border-radius: 3px;
    border-color: #ccc;
    background-color: #ccc
  }

  /deep/ .my-switch.nut-switch .nut-switch-btn {
    border: 2px solid #fff;
    box-shadow: none;
    background-color: #fff;
    border-radius: 3px
  }

  /deep/ .my-switch.nut-switch.nut-switch-active {
    border-color: #409EFF;
    background-color: #409EFF;
  }

  /deep/ .my-switch.nut-switch.nut-switch-active .nut-switch-btn {
    background-color: #fff
  }

  >>> .nut-radio input:checked {
    background-color: #007aff;
    border-color: #007aff;
  }

  >>> .nut-radio input:after {
    background: #007aff;
  }

  >>> .nut-checkbox input:checked {
    background-color: #409EFF;
    border-color: #409EFF;
  }

  >>> .nut-checkbox.nut-checkbox-size-base input {
  }

  >>> .nut-checkbox input:after {
    background: none;
  }

  >>> .nut-button {
    background: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/AddressAdd.vue